export default "__VITE_ASSET__e8c7e59f__"